<template>
  <div class="sf-page">
    <top-header class="no-print"
                v-bind:subtitle="$t('subtitle')"
                v-bind:title="$t('orders')">
      <template slot="right-button">
        <v-btn class="noprint"
               color="primary"
               outlined
               v-on:click="print">
          <v-icon left>ti-printer</v-icon>
          {{ $t('print') }}
        </v-btn>
        <v-btn class="noprint"
               color="primary"
               depressed
               v-bind:loading="exportLoading"
               v-on:click="exportCsv">
          <v-icon left>ti-file-spreadsheet</v-icon>
          {{ $t('export') }}
        </v-btn>
      </template>
    </top-header>
    <div class="sf-container">
      <sticky-bar class="sf-orders__toolbar noprint">
        <v-card class="sf-card"
                flat>
          <div class="sf-toolbar__row">
            <v-text-field class="sf-search sf-toolbar__search"
                          clearable
                          dense
                          flat
                          hide-details
                          prepend-inner-icon="ti-search"
                          solo
                          v-bind:placeholder="$t('search')"
                          v-model="search" />
            <span class="sf-toolbar__hint hidden-xs-only"
                  v-if="!loading">
              {{ $tc('positionCount', orderList.length, { count: orderList.length }) }}
            </span>
          </div>
        </v-card>
      </sticky-bar>

      <order-summary-card hide-header
                          v-bind:filter-text="search"
                          v-bind:items-per-page="itemsPerPage"
                          v-bind:orders="orderList"
                          v-bind:loading="loading"
                          v-bind:is-live="isLive" />
      <p class="sf-note">* {{ $t('allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted') }}</p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import TopHeader from '@/components/common/TopHeader'
  import StickyBar from '@/components/common/StickyBar'
  import OrderSummaryCard from '@/components/OrderSummaryCard'

  export default {
    components: {
      StickyBar,
      OrderSummaryCard,
      TopHeader
    },
    computed: {
      orderList() {
        return [...this.orders].map(o => ({
          ...o,
          price: this.priceForProduct(o.productId)
        })).filter(o => o.quantity > 0)
      },
      ...mapGetters([
        'orders',
        'priceForProduct',
        'isLive'
      ])
    },
    async created() {
      this.loading = true
      await this.$store.dispatch('loadPricesForMe')
      await this.$store.dispatch('loadOrdersForMe')
      this.loading = false
    },
    data: () => ({
      search: null,
      itemsPerPage: 10,
      loading: false,
      exportLoading: false
    }),
    methods: {
      async exportCsv() {
        this.exportLoading = true

        const csv = await this.$store.dispatch('exportOrdersForMe')

        let element = document.createElement('a')
        element.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv))
        element.setAttribute('download', 'export.csv')
        element.style.display = 'none'

        document.body.appendChild(element)

        element.click();

        document.body.removeChild(element)

        this.exportLoading = false
      },
      print() {
        this.itemsPerPage = -1

        setTimeout(() => {
          window.print()
        }, 1000)

      }
    },
    name: 'Orders'
  }
</script>

<style>
  @media print {
    html {
      font-size: 10pt !important;
    }

    .no-print {
      display: none;
    }
  }
</style>

<style scoped>
  .sf-orders__toolbar {
    margin-bottom: 24px;
  }
</style>

<i18n>
  {
    "de": {
      "allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted": "Alle Preise entsprechen der kundenindividuellen Preisliste ohne Konditionen. Irrtümer und Änderungen vorbehalten.",
      "export": "Exportieren",
      "orders": "Bestellungen",
      "print": "Drucken",
      "subtitle": "Alle erfassten Bestellmengen nach Lieferant – zum Bearbeiten auf das Stiftsymbol klicken.",
      "search": "Lieferant oder Artikel suchen",
      "positionCount": "{count} Positionen | {count} Position | {count} Positionen"
    },
    "en": {
      "allPricesCorrespondToTheRespectiveCustomerSpecificPriceListErrorsAndOmissionsExcepted": "All prices correspond to the customer-specific price list. Errors and omissions excepted.",
      "export": "Export",
      "orders": "Orders",
      "print": "Print",
      "subtitle": "All entered quantities by supplier – click the pencil to edit.",
      "search": "Search supplier or product",
      "positionCount": "{count} items | {count} item | {count} items"
    }
  }
</i18n>